export function setCookie(name: string, value: string, expiryDays: number, path = "/" as string) {
	const expiryTimestamp = Date.now() + expiryDays * 24 * 60 * 60 * 1000;
	const expiryDate = new Date(expiryTimestamp);

	document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
		value
	)}; expires=${expiryDate.toUTCString()};path=${path}`;
}

export function getCookie(name: string): string | undefined {
	var b = document.cookie.match(`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`);
	return b ? decodeURIComponent(b.pop()) : undefined;
}

export function hasCookie(name: string): boolean {
	if (document.cookie.split(";").filter((item) => item.trim().startsWith(`${name}=`)).length) {
		return true;
	}

	return false;
}

export function removeCookie(name: string, path = "/" as string) {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path}`;
}
